export function phoneMaskHandler() {
  const telephoneInputs = document.querySelectorAll('input[type="tel"]');

  if(telephoneInputs.length === 0){
    return;
  }

  const isMobile = window.matchMedia("(max-width: 576px)").matches;

  const maskOptions = {
    useFullscreenPopup: isMobile,
    initialCountry: "auto",
    separateDialCode: true,
    customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
      if(selectedCountryData.dialCode === '380'){
        selectedCountryPlaceholder = '50 123 4567'
      }
      return selectedCountryPlaceholder;
    },
    geoIpLookup: callback => {
      fetch("https://ipapi.co/json")
        .then(res => res.json())
        .then(data => callback(data.country_code))
        .catch(() => callback("us"));
    },
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
  }

  telephoneInputs.forEach(telephoneInput => {

    let iti = intlTelInput(telephoneInput, maskOptions);

    // ✅ Manually add fullscreen class if mobile
    if(isMobile) {
      const itiContainer = telephoneInput.closest('.iti');
      if(itiContainer) {
        itiContainer.classList.add('iti--fullscreen-popup');
      }
    }

    const phoneCompleteInput = telephoneInput.closest('form').querySelector('input[name="phone-complete"]');
    const countryInput = telephoneInput.closest('form').querySelector('input[name="country"]');

    telephoneInput.addEventListener('input', () => {

      if(phoneCompleteInput){
        phoneCompleteInput.value = iti.getNumber();
      }

      if(countryInput){
        countryInput.value = iti.getSelectedCountryData().name;
      }
      
    });

    telephoneInput.addEventListener('countrychange', () => {

      if(phoneCompleteInput){
        phoneCompleteInput.value = iti.getNumber();
      }

      if(countryInput){
        countryInput.value = iti.getSelectedCountryData().name;
      }
      
    });  
  
  });
 
}